import { useTranslation } from "react-i18next";
import type { AppointmentType } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import { formatDurationLabel } from "utils/duration";
import AppointmentTypeForm from "./AppointmentTypeForm";

function SidebarAppointmentTypeForm({ ...props }: any) {
  return (
    <CrudEdit
      collectionName="appointment-types"
      Form={AppointmentTypeForm}
      {...props}
    />
  );
}

function AppointmentTypes() {
  const { t } = useTranslation();

  const canManageAppointmentTypes = true;

  const columns: TableColumn<AppointmentType>[] = useMemo(
    () => [
      {
        field: "name",
        header: t("appointment-types.name"),
        sortable: true,
        renderType: "bold",
      },
      {
        field: "color",
        header: t("appointment-types.color"),
        renderType: "color",
      },
      {
        field: "iconName",
        header: t("appointment-types.icon"),
        renderType: "icon",
      },
      {
        field: "duration",
        header: t("appointment-types.duration"),
        customRender: (rowData: AppointmentType) =>
          rowData.duration != null ? (
            <span>{formatDurationLabel(rowData.duration)}</span>
          ) : (
            <span>-</span>
          ),
      },
    ],
    [t]
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        disabled: !canManageAppointmentTypes,
        className: "flex flex-row-reverse",
      },
    ];
  }, [canManageAppointmentTypes, t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("appointment-types.name"),
        renderType: "input",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="appointment-types"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="name:ASC"
      canDelete={canManageAppointmentTypes}
      canEdit={canManageAppointmentTypes}
      icon="WrenchScrewdriverIcon"
      formMode="sidebar"
      SidebarFormComponent={SidebarAppointmentTypeForm}
      actionsHeader=""
    />
  );
}

export default AppointmentTypes;
